import React, { useState } from "react";
import SettingsService from "../../../services/SettingsService";

const AccountSettings = ({ user, showToast }) => {
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [password, setPassword] = useState("");
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [reason, setReason] = useState("");

  const handleDeactivateAccount = async () => {
    if (!password) {
      showToast("Digite sua senha para confirmar", "error");
      return;
    }

    try {
      await SettingsService.deactivateAccount(password, reason);
      showToast("Conta desativada com sucesso");
      // Redirecionar para logout
      setTimeout(() => {
        window.location.href = "/logout";
      }, 2000);
    } catch (error) {
      showToast(error.message || "Erro ao desativar conta", "error");
    }
  };

  const handleDeleteAccount = async () => {
    if (!password) {
      showToast("Digite sua senha para confirmar", "error");
      return;
    }

    if (deleteConfirmation !== "DELETE") {
      showToast('Digite "DELETE" para confirmar', "error");
      return;
    }

    try {
      await SettingsService.deleteAccount(password, deleteConfirmation);
      showToast("Conta excluída com sucesso");
      // Redirecionar para página inicial
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/";
      }, 2000);
    } catch (error) {
      showToast(error.message || "Erro ao excluir conta", "error");
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Configurações da Conta</h1>
        <p>Gerencie as informações e preferências da sua conta</p>
      </div>

      {/* Informações da Conta */}
      <div className="settings-section">
        <h3 className="settings-section-title">📋 Informações da Conta</h3>
        
        <div className="settings-info-card">
          <div className="settings-info-card-title">Informações Básicas</div>
          <div className="settings-info-card-text">
            <p><strong>Nome:</strong> {user.first_name} {user.last_name}</p>
            <p><strong>Usuário:</strong> @{user.username}</p>
            <p><strong>Email:</strong> {user.email || "Não cadastrado"}</p>
            <p><strong>Telefone:</strong> {user.phoneNumber || "Não cadastrado"}</p>
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Editar Perfil</div>
            <div className="settings-item-description">
              Altere suas informações pessoais, foto de perfil e capa
            </div>
          </div>
          <div className="settings-item-control">
            <button 
              className="settings-button settings-button-secondary"
              onClick={() => window.location.href = `/profile/${user.username}`}
            >
              Ir para Perfil
            </button>
          </div>
        </div>
      </div>

      {/* Baixar Dados */}
      <div className="settings-section">
        <h3 className="settings-section-title">📥 Baixar Seus Dados</h3>
        <p className="settings-section-description">
          Solicite uma cópia de todos os seus dados armazenados na plataforma
        </p>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Solicitar Download</div>
            <div className="settings-item-description">
              Você receberá um email quando seus dados estiverem prontos
            </div>
          </div>
          <div className="settings-item-control">
            <button 
              className="settings-button settings-button-primary"
              onClick={async () => {
                try {
                  await SettingsService.requestDataDownload();
                  showToast("Solicitação enviada! Você receberá um email em breve.");
                } catch (error) {
                  showToast(error.message || "Erro ao solicitar download", "error");
                }
              }}
            >
              Solicitar
            </button>
          </div>
        </div>
      </div>

      {/* Zona de Perigo */}
      <div className="settings-section">
        <h3 className="settings-section-title" style={{ color: "#dc3545" }}>
          ⚠️ Zona de Perigo
        </h3>
        <p className="settings-section-description">
          Ações irreversíveis que afetam permanentemente sua conta
        </p>

        <div className="settings-danger-card">
          <div className="settings-danger-card-title">Desativar Conta</div>
          <div className="settings-danger-card-text">
            Desative temporariamente sua conta. Você pode reativá-la a qualquer momento fazendo login novamente.
          </div>
          <button 
            className="settings-button settings-button-danger"
            onClick={() => setShowDeactivateModal(true)}
            style={{ marginTop: "12px" }}
          >
            Desativar Conta
          </button>
        </div>

        <div className="settings-danger-card">
          <div className="settings-danger-card-title">Excluir Conta Permanentemente</div>
          <div className="settings-danger-card-text">
            Esta ação não pode ser desfeita. Todos os seus dados, posts e informações serão excluídos permanentemente.
          </div>
          <button 
            className="settings-button settings-button-danger"
            onClick={() => setShowDeleteModal(true)}
            style={{ marginTop: "12px" }}
          >
            Excluir Conta
          </button>
        </div>
      </div>

      {/* Modal de Desativação */}
      {showDeactivateModal && (
        <div className="modal-overlay" onClick={() => setShowDeactivateModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Desativar Conta</h2>
            <p>Tem certeza que deseja desativar sua conta temporariamente?</p>
            
            <div className="settings-form-group">
              <label className="settings-form-label">Senha</label>
              <input
                type="password"
                className="settings-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">Motivo (opcional)</label>
              <textarea
                className="settings-input"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Conte-nos por que está desativando"
                rows="3"
              />
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                className="settings-button settings-button-secondary"
                onClick={() => setShowDeactivateModal(false)}
              >
                Cancelar
              </button>
              <button
                className="settings-button settings-button-danger"
                onClick={handleDeactivateAccount}
              >
                Desativar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Exclusão */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 style={{ color: "#dc3545" }}>Excluir Conta Permanentemente</h2>
            <p>Esta ação não pode ser desfeita! Todos os seus dados serão perdidos.</p>
            
            <div className="settings-form-group">
              <label className="settings-form-label">Senha</label>
              <input
                type="password"
                className="settings-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">
                Digite "DELETE" para confirmar
              </label>
              <input
                type="text"
                className="settings-input"
                value={deleteConfirmation}
                onChange={(e) => setDeleteConfirmation(e.target.value)}
                placeholder="DELETE"
              />
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                className="settings-button settings-button-secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancelar
              </button>
              <button
                className="settings-button settings-button-danger"
                onClick={handleDeleteAccount}
                disabled={deleteConfirmation !== "DELETE"}
              >
                Excluir Permanentemente
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .modal-content {
          background: var(--bg-secondary);
          padding: 30px;
          border-radius: 12px;
          max-width: 500px;
          width: 90%;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        }

        .modal-content h2 {
          margin-top: 0;
          margin-bottom: 16px;
          color: var(--color-primary);
        }

        .modal-content p {
          margin-bottom: 20px;
          color: var(--color-secondary);
        }

        .modal-content textarea {
          resize: vertical;
        }
      `}</style>
    </div>
  );
};

export default AccountSettings;
